/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_EditInputs */

const vi_packaging_material_edit = /** @type {(inputs: Packaging_Material_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa vật tư`)
};

/**

* @param {Packaging_Material_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_edit = /** @type {((inputs?: Packaging_Material_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_edit(inputs)
});